const createArrayFromLength = (number) =>
  Array.from({ length: number }, (v, i) => i);

module.exports = { createArrayFromLength };
